module.exports = __webpack_public_path__ + "static/A5xF3.ceb33ab7.png";


//////////////////
// WEBPACK FOOTER
// ./images/A5xF3.png
// module id = 880
// module chunks = 168707334958949